import router from '@/router'
import GoogleReviews from '@/views/global/googleReviews/googleReviews.component.vue'

export default {
  name: 'TreatmentsPage',
  components: {
    GoogleReviews
  },
  data () {
    return {
      googleReviewPID: "ChIJOR_Y369x5kcRbHZtyjQgJKY",
      stickyReviews: false,
      slide: 0,
      sliding: null,
      treatmentImages_1: [
        {
          src: "static/Traitements/BulkResizePhotos (1)/1- La patiente se présente avec un défect osseux horizontal sur l'incisive.jpg"
        },/*
        {
          src: "static/Traitements/BulkResizePhotos (1)/2- Le défect est objectivé à l'examen 3D.jpg"
        },*/
        {
          src: "static/Traitements/BulkResizePhotos (1)/2- L'implant est posé en même temps qu'une greffe osseuse est réalisée.jpg"
        }
      ],
      treatmentImages_2: [
        {
          src: "static/Traitements/BulkResizePhotos (2)/1- Cas complexe après pose des implants.jpg"
        },
        {
          src: "static/Traitements/BulkResizePhotos (2)/2- Après réalisation de la prothèse.jpg"
        }
      ],
      treatmentImages_3: [
        {
          src: "static/Traitements/BulkResizePhotos (3)/1- La patiente présente un défaut de hauteur osseux sinusien empêchant la pose d'implant.jpg"
        },
        /*
        {
          src: "static/Traitements/BulkResizePhotos (3)/2- Une fenetre osseuse est réalisée.jpg"
        },
        {
          src: "static/Traitements/BulkResizePhotos (3)/3- Creation du néo-espace sinusien.jpg"
        },
        {
          src: "static/Traitements/BulkResizePhotos (3)/4- Comblement de l'espace.jpg"
        },
        */
        {
          src: "static/Traitements/BulkResizePhotos (3)/2- Obtention d'une hauteur osseuse favorable.jpg"
        },
        {
          src: "static/Traitements/BulkResizePhotos (3)/3- Pose de 2 implants simples.jpg"
        }
      ],
      treatmentImages_4: [
        {
          src: "static/Traitements/BulkResizePhotos (4)/1- Défaut dans le sens horizontal.jpg"
        },
        /*
        {
          src: "static/Traitements/BulkResizePhotos (4)/2- Vue clinique du défaut.jpg"
        },
        */
        {
          src: "static/Traitements/BulkResizePhotos (4)/2- Radio à 6 mois après reconstruction osseuse.jpg"
        }
        /*,
        {
          src: "static/Traitements/BulkResizePhotos (4)/4- Vue clinique lors de la pose implantaire qui confirme le gain obtenu.jpg"
        }
        */
      ],
      treatmentImages_5: [
        {
          src: "static/Traitements/BulkResizePhotos (5)/1- Défect osseux important dans le sens vertical.jpg"
        },
        {
          src: "static/Traitements/BulkResizePhotos (5)/2- Greffe osseuse avec la technique de coffrage.jpg"
        },
        {
          src: "static/Traitements/BulkResizePhotos (5)/3- Radio à 6 mois post-opératoire.jpg"
        },
        {
          src: "static/Traitements/BulkResizePhotos (5)/4- Après pose des implants et réalisation de la prothèse.jpg"
        }
      ],
      treatmentImages_6: [
        {
          src: "static/Traitements/BulkResizePhotos (6)/1- Vue clinique de la fracture dentaire.jpg"
        },
        {
          src: "static/Traitements/BulkResizePhotos (6)/2- Radio montrant la racine résiduelle.jpg"
        },/*
        {
          src: "static/Traitements/BulkResizePhotos (6)/3- Vue clinique post-opératoire immédiate.jpg"
        },*/
        {
          src: "static/Traitements/BulkResizePhotos (6)/3- Radio immédiate post-opératoire qui montre le comblement épousant parfaitement la forme de racine.jpg"
        }
      ],
      treatmentImages_7: [
        {
          src: "static/Traitements/BulkResizePhotos (7)/1- Récession gingivale sur l'incisive.jpg"
        },
        {
          src: "static/Traitements/BulkResizePhotos (7)/2- Après reconstruction de la gencive (à J+15).jpg"
        },
        {
          src: "static/Traitements/BulkResizePhotos (7)/3- Après reconstruction de la gencive (à J+30).jpg"
        }
      ]
    }
  },
  mounted () {
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    },
    getFileName(filepath) {
      var filename = filepath.split('/').pop().split('.')[0]
      return filename
    },
    redirectTo(url) {
      if(url) {
        this.$router.push(url)
      }
    },
    getOffset (el) {
      var _x = 0
      var _y = 0
      while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
        _x += el.offsetLeft - el.scrollLeft
        _y += el.offsetTop - el.scrollTop
        el = el.offsetParent
      }
      return { top: _y, left: _x }
    },
    moonwalk( _parent ) {
      if (!!_parent) {
        gleft += _parent.offsetLeft
        gtop += _parent.offsetTop
        this.moonwalk( _parent.offsetParent )
      } else {
        return rect = {
          top: target.offsetTop + gtop,
          left: target.offsetLeft + gleft,
          bottom: (target.offsetTop + gtop) + target_height,
          right: (target.offsetLeft + gleft) + target_width
        }
      }
    },
    fixReviews () {
      var topPageElements = this.$el.getElementsByClassName('page-title')
      var numberTopElements = topPageElements.length
      if (numberTopElements > 0) {
        var lastTopPageElement = topPageElements[numberTopElements - 1]
        var elementPosition = this.getOffset(lastTopPageElement)
        var currentPosition = document.documentElement.scrollTop || document.body.scrollTop
        if (currentPosition > elementPosition['top']) {
          this.stickyReviews = true
        } else {
          this.stickyReviews = false
        }
      }
    },
    localToGlobal(_el) {
      var target = _el,
      target_width = target.offsetWidth,
      target_height = target.offsetHeight,
      target_left = target.offsetLeft,
      target_top = target.offsetTop,
      gleft = 0,
      gtop = 0,
      rect = {}
      this.moonwalk( target.offsetParent )
      return rect
    }
  },
  created () {
    window.addEventListener('scroll', this.fixReviews);
  },
  destroyed () {
    window.removeEventListener('scroll', this.fixReviews);
  },
  computed: {
  }
}



// WEBPACK FOOTER //
// ./src/views/pages/treatments/treatments.component.js